import Window from "../window/Window";
import React from "react";

function Simulator() {
  let players_list = [];

  const default_value = {
    dragon: {
      names: [
        "KAHGOLRAH",
        "DREYRIIAAL",
        "ZAAMDWIINFEL",
        "WINDIRRAH",
        "FOKLOVLOOST",
        "AGQOTHTIID",
        "ZAHPAHVAAZ",
        "NOKSAHOM",
        "HEYVRIIK",
        "FULZUN",
        "WHITHUS",
        "ACA",
        "ZALLOHOL",
        "FISOS",
        "RENMAN",
        "PY",
        "XUSSIAN",
        "CAL'TYR",
        "FYRETA",
        "FRIBRON",
        "ARRIX",
        "COSSRALD",
        "SASOOT",
        "ENRA",
        "MEHEART",
        "SUDFEU",
        "THRACKZE",
        "BLUELIER",
        "LINHET",
        "TRALNAR",
      ],
      force: [200, 400],
      life: [250, 350],
      skill: [0.5, 0.8],
    },
    knight: {
      names: [
        "Sir Derrick",
        "Prince Reinfrid",
        "Reeve Terryn",
        "Serf Guischard",
        "Peasant Godafre",
        "Alderman Thomelin",
        "Yeoman Iamys",
        "Knight Wiliam",
        "Baronet Drogo",
        "Duke Alfan",
        "Archbishop Bertaut",
        "Monk Blavier",
        "Knight Randolph",
        "Grand Duke",
        "Wylymot Serf",
        "Jeacock Landgrave",
        "Jeffcock Baronet",
        "Daniau Margrave",
        "Hugelin Admiral",
        "Nicol Count",
        "Dedericus Count",
        "Blavier Prince",
        "Berengar Archbishop",
        "Raymond Emperor",
        "Jehen Landgrave",
        "Garin Prince",
        "Consort Ilbertus",
        "Baronet Milot",
        "Emperor Tetbald",
        "Landgrave Iordanus",
        "Vicar Hanekin",
        "Prince Walter",
        "Squire Gaillart",
        "Sir Goscelinus",
        "Peasant Walkelin",
        "Archbishop Hervoet",
        "Squire Ivote",
        "Vicar Brian",
        "Earl Bernier",
        "Prince Heimart",
        "Yeoman Blavier",
        "Baron Aalart",
        "Baron Abel",
        "Duke Beves",
        "Baron Hanequin",
        "Viscount Remonnet",
        "Serf Bertrand",
        "Archbishop Bardolph",
        "Yeoman Otelin",
        "Margrave Ascelyn",
        "Count Humpherus",
      ],
      force: [15, 20],
      life: [25, 50],
      skill: [0.5, 1],
    },
    humain: {
      names: ["Joe"],
      force: [1, 10],
      life: [20, 50],
      skill: [0.5, 0.9],
    },
  };

  function random(min, max) {
    return Math.ceil(Math.random() * (max - (min - 1)) + (min - 1));
  }

  function tryAction(percent) {
    let chance = (1 - percent) * 100;
    let r = Math.ceil(Math.random() * 100 + 0);
    let result = false;
    if (r >= chance) result = true;
    return result;
  }

  class Game {
    constructor(players) {
      this.players = players;
      this.time = 5000;
    }

    set setTime(new_time) {
      this.time = new_time;
    }

    run() {
      if (!this.players) {
        console.error("Erreur, pas de participant");
        return;
      }
      logger("");
      logger("----------------------------------------------");
      logger("----------------------------------------------");
      logger("----------------------------------------------");
      logger("----------------------------------------------");
      logger("DEBUT DU COMBAT");
      console.table(this.players);

      for (let i = 0; i < this.players.length; i++) {
        let player = this.players[i];

        let li = document.createElement("li");
        let img = document.createElement("img");
        let name = document.createElement("h1");
        let detail = document.createElement("div");
        let content = document.createElement("div");
        let extra_a = document.createElement("div");
        let extra_b = document.createElement("div");
        let skill = document.createElement("p");
        let strength = document.createElement("p");
        let life = document.createElement("span");
        let life_text = document.createElement("p");
        let armor = document.createElement("span");
        let armor_text = document.createElement("p");

        life.id = "life-" + player.name + player.force + player.skill;
        armor.id = "armor-" + player.name + player.force + player.skill;
        life.innerHTML = player.life;
        armor.innerHTML = player.armor;
        life_text.innerHTML = "Vie : ";
        life_text.appendChild(life);
        armor_text.innerHTML = "Armure : ";
        armor_text.appendChild(armor);

        skill.innerHTML = "Talent : " + player.skill * 100 + "%";
        strength.innerHTML = "Force : " + player.force;
        extra_b.appendChild(skill);
        extra_b.appendChild(strength);

        name.innerHTML = player.name;

        extra_a.appendChild(life_text);
        extra_a.appendChild(armor_text);

        li.id = "li-" + player.name + player.force + player.skill;

        if (player.type == "knight") {
          img.src = "https://cdn-icons-png.flaticon.com/512/728/728888.png";
          img.alt = "Knight icons created by Chanut-is-Industries - Flaticon"
          li.style.backgroundColor = "rgba(255,255,255,0.1)";
        } else if (player.type == "dragon") {
          img.src = "https://cdn-icons-png.flaticon.com/512/5240/5240875.png";
          img.alt = "Dragon icons created by Freepik - Flaticon"
        }

        /*
        player.index;
        let t = "";
        if (player.type == "knight") {
          t = "🤴";
        } else if (player.type == "dragon") {
          t = "🔥";
        }
        
        li.appendChild(img);
        detail.innerHTML = "Life : "
        detail.appendChild(life);
        li.appendChild(name);
        li.appendChild(detail);
        li.id = "li-" + player.name + player.force + player.skill;
        li.className = player.type;
        li.appendChild(life);
        li.innerHTML = li.innerHTML + "<br />Armor : ";
        li.appendChild(armor);
        */

        detail.appendChild(extra_a);
        detail.appendChild(extra_b);

        content.appendChild(name);
        content.appendChild(detail);

        li.appendChild(img);
        li.appendChild(content);

        if (player.type == "knight") {
          document.getElementById("knights").appendChild(li);
        } else if (player.type == "dragon") {
          document.getElementById("dragons").appendChild(li);
        }
      }

      this.turn();
    }

    turn() {
      setTimeout(() => {
        let dragons = this.players
          .filter((player) => player.type == "dragon")
          .filter((p) => p.life >= 1);
        let players = this.players
          .filter((player) => player.type != "dragon")
          .filter((p) => p.life >= 1);

        if (players.length <= 0) {
          this.finish(dragons);
          return;
        } else if (dragons.length <= 0) {
          this.finish(players);
          return;
        }

        logger(" ");
        logger("--------------");

        let target = players[random(0, players.length - 1)];

        dragons[random(0, dragons.length - 1)]
          .attack(target, this.time)
          .then((response) => {
            if (response.life <= 0) {
              this.turn(this.time);
            } else {
              response.attack(response.was_attacked_by, this.time).then(() => {
                this.turn(this.time);
              });
            }
          });
      }, this.time);
    }

    finish(winners) {
      logger("");
      logger("🔜🔜🔜🔜🔜🔜🔜🔜🔜🔜🔜");

      if (winners[0].type == "dragon") {
        logger("Tout les chevaliers sont morts, victoire des dragons !");
      } else if (winners[0].type == "knight") {
        logger("Tout les dragons sont morts, victoire des chevaliers !");
      }
      console.table("🏆 Les gagnants encore en vie :");
      console.table(winners);
      console.table("📊 Les statistiques finales :");
      console.table(this.players);
      return;
    }
  }

  class Player {
    constructor(name, force, life) {
      this.type = "humain";

      let d_values = default_value.humain;
      this.name = name || d_values.names[random(0, d_values.names.length - 1)];
      this.force = force || random(d_values.force[0], d_values.force[1]);
      this.life = life || random(d_values.life[0], d_values.life[1]);

      this.was_attacked_by;
      this.shot = 0;
      this.skill = 0.8;
      this.armor = 0;
      this.critical = true;
    }

    attack(target, time) {
      let attacker = this;
      if (attacker.type == "dragon") {
        logger(
          "🔥 " + attacker.name + " s'élance pour attaquer " + target.name
        );
      } else if (attacker.type == "knight") {
        logger(
          "🔙 " +
            attacker.name +
            " s'élance pour riposter contre " +
            target.name
        );
      }
      return new Promise(function (successCallback, failureCallback) {
        setTimeout(() => {
          if (tryAction(attacker.skill)) {
            logger("✅ Attaque réussi !");
            let damage = random(0.75 * attacker.force, 1.25 * attacker.force);
            if (attacker.critical && tryAction(attacker.skill * 0.75)) {
              logger("💥 COUP CRITIQUE !");
              damage = damage * 4;
            }
            logger(damage + " débats !");
            target.hit(damage, attacker);
            attacker.shot = attacker.shot + 1;
            if (attacker.critical && tryAction(attacker.skill * 0.75)) {
              setTimeout(() => {
                logger(
                  "🔙🔙 " +
                    attacker.name +
                    " enchaîne avec une seconde attaque !"
                );
                if (attacker.critical && tryAction(attacker.skill * 0.75)) {
                  logger("💥💥 COUP CRITIQUE !");
                  damage = damage * 4;
                }
                logger(damage + " débats !");
                target.hit(damage, attacker);
                attacker.shot = attacker.shot + 1;
                successCallback(target);
              }, time);
            } else {
              successCallback(target);
            }
          } else {
            logger("❌ Attaque ratée !");
            target.hit(0, attacker);
            successCallback(target);
          }
        }, time);
      });
    }

    hit(damage, attacker) {
      let target = this;
      target.was_attacked_by = attacker;
      if (this.armor > 0) {
        target.armor = target.armor - damage / 4;
      } else {
        target.life = target.life - damage;
      }
      if (target.life <= 0) {
        logger("💀 " + target.name + " meurt au combat !");
      } else {
        if (target.armor > 0) {
          logger(
            target.name +
              ` a subi ${damage} dégâts, il lui reste ${target.life} vies et ${target.armor} point d'armure`
          );
        } else {
          logger(
            target.name +
              ` a subi ${damage} dégâts, il lui reste ${target.life} vies`
          );
        }
      }
      let ar = document.getElementById(
        "armor-" + target.name + target.force + target.skill
      );
      let li = document.getElementById(
        "life-" + target.name + target.force + target.skill
      );
      let ul = document.getElementById(
        "li-" + target.name + target.force + target.skill
      );
      ar.innerHTML = target.armor;
      li.innerHTML = target.life;
      if (target.armor > 0) ul.style.backgroundColor = "rgba(255,255,255,0.1)";
      if (target.armor <= 0) ul.style.backgroundColor = "rgba(255,255,255,0)";
      if (target.life <= 0) ul.style.backgroundColor = "rgba(200,100,100,0.5)";
    }
  }

  class Dragon extends Player {
    constructor(name, force, life, skill) {
      super(name, force, life, skill);
      this.type = "dragon";
      this.skill = 1;
      this.critical = false;

      let d_values = default_value.dragon;
      this.name = name || d_values.names[random(0, d_values.names.length - 1)];
      this.force = force || random(d_values.force[0], d_values.force[1]);
      this.life = life || random(d_values.life[0], d_values.life[1]);
      this.skill =
        skill || random(d_values.skill[0] * 10, d_values.skill[1] * 10) / 10;
    }
  }

  class Knight extends Player {
    constructor(name, force, life, skill) {
      super(name, force, life, skill);

      this.armor = 150;
      this.type = "knight";
      this.skill = 0.8;
      this.critical = true;

      let d_values = default_value.knight;
      this.name = name || d_values.names[random(0, d_values.names.length - 1)];
      this.force = force || random(d_values.force[0], d_values.force[1]);
      this.life = life || random(d_values.life[0], d_values.life[1]);
      this.skill =
        skill || random(d_values.skill[0] * 10, d_values.skill[1] * 10) / 10;
    }
  }

  const dragon1 = new Dragon();
  const dragon2 = new Dragon();
  const dragon3 = new Dragon();
  const dragon4 = new Dragon();
  const dragon5 = new Dragon();
  const dragon6 = new Dragon();
  const knight1 = new Knight();
  const knight2 = new Knight();
  const knight3 = new Knight();
  const knight4 = new Knight();
  const knight5 = new Knight();
  const knight6 = new Knight();

  // const game = new Game([dragon1, knight1]);

  function start() {
    document.getElementById("log").innerHTML = "";
    document.getElementById("dragons").innerHTML = "";
    document.getElementById("knights").innerHTML = "";
    players_list = [];
    let number_of_knights = document.getElementById("number_of_knights").value;
    if (number_of_knights > 100) return;
    if (!number_of_knights) number_of_knights = 2;
    for (let i = 0; i < number_of_knights; i++) {
      let knight = new Knight();
      players_list.push(knight);
    }
    let number_of_dragons = document.getElementById("number_of_dragons").value;
    if (number_of_dragons > 100) return;
    if (!number_of_dragons) number_of_dragons = 2;
    for (let i = 0; i < number_of_dragons; i++) {
      let dragon = new Dragon();
      players_list.push(dragon);
    }
    const game = new Game(players_list);

    let time = document.getElementById("time").value;
    if (!time) time = 100;
    game.setTime = time;
    game.run();
  }

  function logger(text) {
    let p = document.createElement("p");
    p.innerHTML = text;
    let doc = document.getElementById("log");
    doc.appendChild(p);
    doc.scrollTo(0, doc.scrollHeight);
  }

  return (
    <Window id="simulator" title="Dragon vs. Knight">
      <div>
        <p>Nombre de chevaliers (max 100)</p>
        <input id="number_of_knights" />
        <p>Nombre de dragons  (max 100)</p>
        <input id="number_of_dragons" />
        <p>Temps entre chaque actions (ms)</p>
        <input id="time" />
        <button onClick={start}>Start</button>
        <p>
          Ce jeu de simulation était un petit projet pour la fin de la première
          semaine de cours à la 3WAcademy. Il a été réalisé en 2 jours. Le code
          final réel est disponible ici :
          https://codepen.io/vingt-douze/pen/bGMPjOo
          <br />
          L'objectif étant de créer un combat entre chevalier et dragon en utilisant les class
          <br />
          <br />
          Scénario : Un dragon aléatoire attaque en premier, puis c'est au
          chevalier visé de contre-attaquer.
          <br />
          <br />
          Caractéristique : Les dragons ont une chance de rater leur attaque,
          les chevaliers ont également une chance de rater leur attaque mais ont
          aussi une chance de faire des coups critiques ainsi qu'une seconde attaque.
        </p>
      </div>
      <div id="players">
        <ul id="knights"></ul>
        <ul id="dragons"></ul>
      </div>
      <div id="log"></div>
    </Window>
  );
}

export default Simulator;
